export default __webpack_public_path__ + "static/media/upgrade-icon-3.5d95dcb1.png";